// core
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class RaptorApiService {

  constructor(private http: HttpClient, @Inject('environment') private environment: any) { }

  get(url: string): Observable<any> {
    let response = this.http.get<any>(url.indexOf('http') === 0 ? url :  `${this.environment.apiEndpoint}${url}`);

    return this.getApiResponse(response);
  }

  post(url: string, payload: any): Observable<any>  {
    let response = this.http.post<any>(`${this.environment.apiEndpoint}${url}`, payload);

    return this.getApiResponse(response);
  }

  put(url: string, payload: any): Observable<any> {
    let response = this.http.put(`${this.environment.apiEndpoint}${url}`, payload);
    this.http.patch
    return this.getApiResponse(response);
  }

  patch(url: string, payload: any): Observable<any> {
    let response = this.http.patch(`${this.environment.apiEndpoint}${url}`, payload);
    return this.getApiResponse(response);
  }

  private getApiResponse(response: Observable<any>): Observable<any> {
    return new Observable(subscriber => {
      response.subscribe((successResponse: any) => {
        subscriber.next(successResponse);

        subscriber.complete();
      },
      errorResponse => {
        subscriber.error(errorResponse);
      });
    });
  }
}
